import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
const PswModal = forwardRef((props, ref) => {
   const { record: propRecord,onSuccess } = props; 
  const [form] = Form.useForm(); 
  const [loading, setLoading] = useState(false);
  const [modelReset, setModelReset] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  useImperativeHandle(ref, () => ({
    setModelReset: (flag, record) => {
      setModelReset(flag);
      const actualRecord = record || propRecord; 
      if (flag && actualRecord) {
        setCurrentRecord(actualRecord); 
        form.setFieldsValue({
          newPassword: "",
          confirmPassword: "",
          _record: actualRecord,
        });
      
      }
    },
  }));

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const { _record, ...passwords } = values;
      const queryParams = {
        accountId: _record.accountId,
        password: passwords.newPassword,
        confirmPassword: passwords.confirmPassword,
      };
      const response = await http.post(
        `${api.getEditPasswordAdmin}`,
        queryParams
      );
      if (response.code === "1") {
        message.success("Password modified successfully.");
        setModelReset(false);
           onSuccess?.();
        // window.location.reload();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // 密码验证规则
  const passwordRules = [
    { required: true, message: 'Please input your password!' },
    { min: 6, message: 'Password must be at least 6 characters!' }
  ];

  // 确认密码验证
  const validateConfirmPassword = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('The two passwords do not match!'));
    },
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            PASSWORD RESET
          </Typography.Title>
        </Flex>
      }
      width="50%"
      open={modelReset}
      onCancel={() => setModelReset(false)}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button key="back" onClick={() => setModelReset(false)}>
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              {...layout}
              name="passwordResetForm"
              onFinish={onFinish}
              form={form}
              labelCol={{
                style: {
                  width: "150px",
                },
              }}
              wrapperCol={{
                style: {
                  flex: 1,
                },
              }}
            >
              <Form.Item
                name="newPassword"
                label="New Password"
                rules={passwordRules}
              >
                <Input.Password
                  placeholder="Please enter a new password."
                  allowClear
                />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                dependencies={["newPassword"]}
                rules={[
                  {
                    required: true,
                    message: "Please enter the password again.",
                  },
                  validateConfirmPassword,
                ]}
              >
                <Input.Password
                  placeholder="Please enter the password again."
                  allowClear
                />
              </Form.Item>

              <Form.Item name="_record" noStyle>
                <Input type="hidden" />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default PswModal;